import { NgModule } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { FormPlycaModule } from '../components/forms/formPlyca.module';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { IncomeComponent } from './income.component';

@NgModule({
  declarations: [IncomeComponent],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    FormPlycaModule
  ]
})
export class IncomeModule { }
